import Preact from 'preact'
import Loadable from 'react-loadable'
import { LoadableLoader } from './common/Loader'

const { h } = Preact

const common = {
  delay: 300,
  loading: LoadableLoader,
  timeout: 15000
}

export const HomeRoute = Loadable({
  ...common,
  module: ['HomePage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/HomePage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "HomePage"*/ './pages/HomePage').then(
      ({ HomePage }) => HomePage
    )
})

export const ScheduleRoute = Loadable({
  ...common,

  module: ['SchedulePage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/SchedulePage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "SchedulePage" */ './pages/SchedulePage').then(
      ({ SchedulePage }) => SchedulePage
    )
})

export const GroupsRoute = Loadable({
  ...common,

  module: ['GroupsPage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/GroupsPage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "GroupsPage" */ './pages/GroupsPage').then(
      ({ GroupsPage }) => GroupsPage
    )
})

export const KnockoutRoute = Loadable({
  ...common,
  module: ['KnockoutPage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/KnockoutPage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "KnockoutPage"*/ './pages/KnockoutPage/index').then(
      ({ KnockoutPage }) => KnockoutPage
    )
})

export const MatchRoute = Loadable({
  ...common,

  module: ['MatchPage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/MatchPage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "MatchPage" */ './pages/MatchPage').then(
      ({ MatchPage }) => MatchPage
    )
})

export const GoalShowRoute = Loadable({
  ...common,
  module: ['GoalShowPage'],
  webpack: () => {
    // @ts-ignore
    return [require.resolveWeak('./pages/GoalShowPage/index')]
  },
  loader: () =>
    import(/* webpackChunkName: "GoalShowPage"*/ './pages/GoalShowPage').then(
      ({ GoalShowPage }) => GoalShowPage
    )
})
